import { Button, Card } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, useSite } from '../../../context/page-context';
import { getOnboardingMeetingLink } from '../lib/onboarding';

export function OnboardingCard() {
  const { userEmail } = useSite();
  const { navigationHandler } = useHandlers();
  const onBoardingMeetingLink = getOnboardingMeetingLink(userEmail);

  return (
    <Card>
      <Card.Header icon="chat" headingLevel="h2">
        {t('features:home.components.onboarding_card.title')}
      </Card.Header>
      <Card.Body justifyBetween>
        {t('features:home.components.onboarding_card.description')}
        <Button
          variant="secondary"
          onClick={() =>
            navigationHandler.navigate(onBoardingMeetingLink, {
              newTab: true,
              absolute: true,
            })
          }
        >
          {t('features:home.components.onboarding_card.action')}
        </Button>
      </Card.Body>
    </Card>
  );
}
